// extracted by mini-css-extract-plugin
export default {"PaaSProject":"PaaSProject_PaaSProject__kh0eM"};